import { createClient } from '@supabase/supabase-js'
import type { Database } from '@/integrations/supabase/types'

// Nota: integrations/supabase/client.ts usa VITE_SUPABASE_PUBLISHABLE_KEY.
// Este arquivo usa VITE_SUPABASE_ANON_KEY para compatibilidade com .env existente.
// Ambos os nomes referem-se à mesma chave (anon/public).
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
})